import axios from "axios";
import { API_BASE_URL } from "./BaseUrl";
 

axios.interceptors.response.use((response) => response, (error) => {
   console.log(error,"ERROROOROR")
   if ((error?.response?.data?.status === 401) || error?.response?.status === 401) {
      localStorage.clear();
      window.location.href = "/login"
   } else {
      throw error
   }
});

export const postApiWithoutToken = (path, data) => {
   return axios.post(API_BASE_URL + path, data, {
      headers: {
         "Content-Type": "application/json",
      },
   });
};

export const putApiWithoutToken = (path, data) => {
   return axios.put(API_BASE_URL + path, data, {
      headers: {
         "Content-Type": "application/json",
      },
   });
};

export const postApiWithToken = (path, data) => {
   const token = localStorage.getItem("token");

   return axios.post(API_BASE_URL + path, data, {
      headers: {
         "Content-Type": "application/json",
         Authorization: `Bearer ${token}`,
      },
   });
};

export const getApiWithToken = (path) => {
   const token = localStorage.getItem("token");
   // console.log(token, "Token Form getApi'ssssssssssssssssssssssssssss")
   // const token =  "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VySWQiOjEsImlhdCI6MTY4NTQyODk0OH0.SMGhrQZqBIhN8fKnOxznBmuyGf9B7ZRCraPPeMCEsMc"








  
   return axios.get(API_BASE_URL + path, {
      headers: {
         "Content-Type": "application/json",
         Authorization: `Bearer ${token}`,
      },
   });
};

export const imgUploadApi = (path, data) => {
   const token = localStorage.getItem("token");

   return axios.post(API_BASE_URL + path, data, {
      headers: {
         "Content-Type": "multipart/form-data",
         Authorization: `Bearer ${token}`,
      },
   });
};

export const getApiWithoutToken =  (path) => {
   return  axios.get(API_BASE_URL + path, {
      headers: {
         "Content-Type": "application/json",
      },
   }
   );
};

export const putApiWithToken = (path, data) => {
   const token = localStorage.getItem("token");

   return axios.put(API_BASE_URL + path, data, {
      headers: {
         "Content-Type": "application/json",
         Authorization: `Bearer ${token}`,
      },
   });
};

export const deleteApi = (path, data) => {
   const token = localStorage.getItem("token");
   return axios.delete(API_BASE_URL + path, {
      data: data,
      headers: {
         "Content-Type": "application/json",
         Authorization: `Bearer ${token}`,
      }
   });
};


